import { Locale } from 'signup-ui-lego-core/constants/Locale';
import { getApplicationLocale } from '../i18n/LocaleUtils';
import { HubletOption } from 'signup-constants/signupData/HubletOption';
import imageUrls from '../images/imageUrls';
const KnowledgeBaseLanguage = {
  [Locale.ja]: 'jp',
  [Locale.ptBr]: 'pt'
};
export const getKnowledgeBaseLink = (locale = getApplicationLocale()) => {
  let knowledgeArticleUrl = 'https://knowledge.hubspot.com';
  if (locale !== Locale.en) {
    const articleLanguage = KnowledgeBaseLanguage[locale] || locale;
    knowledgeArticleUrl = `${knowledgeArticleUrl}/${articleLanguage}`;
  }
  knowledgeArticleUrl = `${knowledgeArticleUrl}/account/hubspot-cloud-infrastructure-and-data-hosting-frequently-asked-questions`;
  return knowledgeArticleUrl;
};
export const HubletToImageUrl = {
  [HubletOption.eu1]: imageUrls.hubletEu,
  [HubletOption.na1]: imageUrls.hubletUS
};